import { TranslationsInterface } from "../interfaces/shared/TranslationsInterface";

export const StringTranslation = (
    key: string,
    texts: TranslationsInterface | undefined | null,
): string => {
    const entry = texts?.[key];

    if (typeof entry !== "string") {
        return "Missing translations for key: " + key;
    }

    return entry;
};
